"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionSelectorModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const storm_ui_1 = require("@amzn/storm-ui");
const TranslationProvider_1 = require("../shared/TranslationProvider/TranslationProvider");
const RegionSelectorDropdown_1 = require("../shared/RegionSelectorDropdown/RegionSelectorDropdown");
const Constants_1 = require("../../utils/Constants");
const resolveRegionalUrl_1 = require("../../utils/resolveRegionalUrl");
const RegionSelectorModalFooter_1 = require("../shared/RegionSelectorModalFooter/RegionSelectorModalFooter");
const RegionSelectorModalHeader_1 = require("../shared/RegionSelectorModalHeader/RegionSelectorModalHeader");
const Wrapper = styled_components_1.default.div `
  width: 272px;
`;
const RegionSelectorModal = ({ entityKeys, isModalOpen, applicationUrl, toggleModal, language = 'en-US', }) => {
    const [selectedRegion, setSelectedRegion] = (0, react_1.useState)();
    const buttonRef = (0, react_1.useRef)();
    const onChange = (dropdownItem) => {
        if (dropdownItem) {
            setSelectedRegion(dropdownItem);
        }
    };
    const onContinueClick = () => {
        if (selectedRegion) {
            window.location.assign((0, resolveRegionalUrl_1.resolveRegionalUrl)(applicationUrl, selectedRegion, entityKeys));
        }
    };
    return ((0, jsx_runtime_1.jsx)(storm_ui_1.ThemeProvider, { children: (0, jsx_runtime_1.jsx)(TranslationProvider_1.TranslationProvider, { locale: language, children: (0, jsx_runtime_1.jsx)(storm_ui_1.Modal, { isOpen: isModalOpen, header: (0, jsx_runtime_1.jsx)(RegionSelectorModalHeader_1.RegionSelectorModalHeader, {}), footer: (0, jsx_runtime_1.jsx)(RegionSelectorModalFooter_1.RegionSelectorModalFooter, { toggleModal: toggleModal, onContinueClick: onContinueClick }), onClose: () => toggleModal, toggleEl: buttonRef.current, "data-testid": Constants_1.regionSelectorModalTestId, children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)(RegionSelectorDropdown_1.RegionSelectorDropdown, { onChange: onChange, selectedValue: selectedRegion, entityKeys: entityKeys }) }) }) }) }));
};
exports.RegionSelectorModal = RegionSelectorModal;
exports.default = exports.RegionSelectorModal;
//# sourceMappingURL=RegionSelectorModal.js.map